import { trackingFormModel, reportsFormModel } from "./formModel";
import * as Yup from "yup";
import { isEmpty } from "lodash";

const { formFields } = trackingFormModel;

export const trackingValidationSchema = Yup.object().shape({
  [formFields.trackingNumbers.name]: Yup.array().of(
    Yup.object().shape({
      value: Yup.string()
        .matches(/^[a-zA-Z0-9]+$/, formFields.trackingNumbers.errMsg.invalid)
        .typeError(formFields.trackingNumbers.errMsg.invalid)
        .required(formFields.trackingNumbers.errMsg.required),
    })
  ),
});

export const getValidationSchema = (trackingNumbers = []) => {
  if (!isEmpty(trackingNumbers) && trackingNumbers.length > 1) {
    return Yup.object({
      ...trackingNumbers
        .map(({ name }) => ({
          [name]: Yup.string()
            .matches(
              /^[a-zA-Z0-9]+$/,
              formFields.trackingNumbers.errMsg.invalid
            )
            .typeError(formFields.trackingNumbers.errMsg.invalid)
            .required(formFields.trackingNumbers.errMsg.required),
        }))
        .reduce((acc, curr) => ({ ...acc, ...curr }), []),
    });
  }

  return Yup.object({
    trackingNumbers: Yup.string()
      .matches(/^[a-zA-Z0-9]+$/, formFields.trackingNumbers.errMsg.invalid)
      .required(formFields.trackingNumbers.errMsg.required),
  });
};

export const getPodValidationSchema = (trackingNumbers = []) => {
  return Yup.object({
    ...trackingNumbers
      .map(({ name }) => ({
        [name]: Yup.string()
          .matches(/^[a-zA-Z0-9]+$/, formFields.trackingNumbers.errMsg.invalid)
          .typeError(formFields.trackingNumbers.errMsg.invalid)
          .required(formFields.trackingNumbers.errMsg.required),
      }))
      .reduce((acc, curr) => ({ ...acc, ...curr }), []),
  });
};

export const quickAccessTrackingValidationSchema = Yup.object({
  [formFields.trackingNumbers.name]: Yup.string()
    .matches(/^[a-zA-Z0-9]+$/, formFields.trackingNumbers.errMsg.invalid)
    .required(formFields.trackingNumbers.errMsg.required),
});

const {
  formFields: { sortReportOption, typeReportOption },
} = reportsFormModel;

export const reportsValidationSchema = Yup.object({
  [typeReportOption.name]: Yup.string().required(
    typeReportOption.errMsg.required
  ),
  [sortReportOption.name]: Yup.string().required(
    sortReportOption.errMsg.required
  ),
});
